import React from 'react';
import { FormattedMessage, useIntl } from '@futrli/localisation';

import Button from 'carbon-react/lib/components/button';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Typography from 'carbon-react/lib/components/typography';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeletePageModal = ({ isOpen, onClose, onDelete }: Props) => {
  const intl = useIntl();
  return (
    <Dialog
      title={intl.formatMessage({ id: 'reporting.delete_page.headline', defaultMessage: 'Delete page' })}
      onCancel={onClose}
      open={isOpen}
      size="medium"
      contentPadding={{
        p: 0
      }}
      aria-label={intl.formatMessage({
        id: 'reporting.delete_dialog.aria_label',
        defaultMessage: 'Delete dialog'
      })}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={onClose} size="small" buttonType="secondary">
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" destructive size="small" onClick={onDelete}>
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        }
        onSubmit={() => null}
      >
        <Typography px={3} py="20px" mb={0}>
          <FormattedMessage
            id="reporting.are_you_sure_delete_page"
            defaultMessage="Are you sure you want to delete this page?"
          />
        </Typography>
      </Form>
    </Dialog>
  );
};
